export const INTERPRETATIONS_RECEIVED = "INTERPRETATIONS_RECEIVED";
export const SET_INTERPRETATION = "SET_INTERPRETATION";
